"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var SingleSelect_1 = __importDefault(require("../SingleSelect"));
var DecisionMenu_1 = __importDefault(require("./DecisionMenu"));
function DecisionButtonAndDropdown(_a) {
    var decisionOptions = _a.decisionOptions, queueOptions = _a.queueOptions, decisionLabel = _a.decisionLabel, dropdownTitle = _a.dropdownTitle, onChange = _a.onChange, shortcut = _a.shortcut, isSelected = _a.isSelected, isDisabled = _a.isDisabled, className = _a.className, isSearchPage = _a.isSearchPage, dataCy = _a.dataCy, enableKeyboardShortcuts = _a.enableKeyboardShortcuts, changeFocusedElement = _a.changeFocusedElement;
    var containerRef = (0, react_1.createRef)();
    (0, react_1.useEffect)(function () {
        var handleKeyDown = function (event) {
            var _a;
            if (enableKeyboardShortcuts && document.activeElement === document.body) {
                if (event.key === (shortcut === null || shortcut === void 0 ? void 0 : shortcut.toLowerCase())) {
                    // if there is only one button (send to queue), and this button only has one item in the drop down list,
                    // select the first item directly
                    if (queueOptions && queueOptions.length === 1) {
                        onChange(queueOptions[0]);
                        event.preventDefault();
                        return;
                    }
                    if (!showDropdown)
                        changeFocusedElement && changeFocusedElement(containerRef);
                    setShowDropdown(true);
                    (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    event.preventDefault();
                }
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return function () {
            document.removeEventListener('keydown', handleKeyDown);
        };
    });
    (0, react_1.useEffect)(function () {
        if (isDisabled) {
            setShowDropdown(false);
        }
    }, [isDisabled]);
    var _b = __read((0, react_1.useState)(false), 2), showDropdown = _b[0], setShowDropdown = _b[1];
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)("eva-drop-down-with-search dropdrown dropup open ".concat(className), isDisabled && 'is-disabled', isSelected && 'selected', { 'eva-keyboard-focused': showDropdown }), onMouseEnter: function () { return setShowDropdown(true); }, onMouseLeave: function () { return setShowDropdown(false); }, ref: containerRef, onFocus: function () { return setShowDropdown(true); }, onBlur: function () { return setShowDropdown(false); }, tabIndex: -1 },
        react_1.default.createElement("button", { type: "button", "data-cy": dataCy, className: "btn eva-decision-button", onClick: function () { return setShowDropdown(true); } },
            shortcut && react_1.default.createElement("span", { className: "eva-shortcut-icon" }, shortcut),
            react_1.default.createElement("span", { className: "eva-button-text" }, decisionLabel),
            react_1.default.createElement("span", { className: "implioicons-arrow-3-down eva-dropdown-caret" })),
        showDropdown && isSearchPage && decisionOptions && (react_1.default.createElement("div", { className: "dropdown-menu refuse-dropdown-container", role: "menu" },
            react_1.default.createElement(SingleSelect_1.default, { options: decisionOptions, getOptionLabel: function (valueItem) { return valueItem.name; }, getOptionValue: function (valueItem) { return String(valueItem.id); }, onChange: function (valueItem) {
                    setShowDropdown(false);
                    onChange(valueItem);
                }, className: "refuse-dropdown", isSearchable: true, defaultMenuIsOpen: true, isMenuPositionStatic: true, autoFocus: true, withSearchInputIcon: true, withTooltipAndTruncatedText: true }))),
        showDropdown && !isSearchPage && decisionOptions && (react_1.default.createElement(DecisionMenu_1.default, { data: decisionOptions.map(function (d) { return ({ name: d.name, id: String(d.id) }); }), onChange: function (valueItem) {
                setShowDropdown(false);
                onChange(decisionOptions.find(function (d) { return String(d.id) === String(valueItem.id); }));
            }, dropDownTitle: dropdownTitle, dropDirectionClass: "dropup", dataCy: "item-detail-refuse-button" })),
        showDropdown && !isSearchPage && queueOptions && (react_1.default.createElement(DecisionMenu_1.default, { data: queueOptions.map(function (q) { return ({ name: q.label, id: q.id }); }), onChange: function (valueItem) {
                setShowDropdown(false);
                onChange(queueOptions.find(function (queue) { return queue.id === valueItem.id; }));
            }, dropDownTitle: dropdownTitle, dropDirectionClass: "dropup", dataCy: "item-detail-send-to-queue-button" }))));
}
exports.default = DecisionButtonAndDropdown;
